/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadClientSystemSetting$Params {
  clientID: number;
      body?: {
'systemSettingID'?: number;
'companyID'?: number;
'file'?: Blob;
}
}

export function UploadClientSystemSetting(http: HttpClient, rootUrl: string, params: UploadClientSystemSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, UploadClientSystemSetting.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

UploadClientSystemSetting.PATH = '/api/Clients/UploadClientSystemSetting/{clientID}';
